'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _query = require('utilities/query');

var _adminUserList = require('./admin-user-list.html');

var _adminUserList2 = _interopRequireDefault(_adminUserList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _adminUserList2.default,
  bindings: {
    users: '<',
    selectedUsers: '<',
    userLockoutChanged: '&',
    locked: '<',
    query: '<',
    queryChanged: '&',
    searchTextChanged: '&',
    showColumns: '<'
  },
  controller: function () {
    function AdminUserListComponent(EventEmitter) {
      'ngInject';

      var _this = this;

      _classCallCheck(this, AdminUserListComponent);

      Object.assign(this, { EventEmitter: EventEmitter });

      this.onPaginationChanged = function (page, take) {
        _this.onQueryChange(_extends({}, _this.query, {
          page: page,
          take: take
        }));
      };

      this.onOrderChanged = function (order) {
        var direction = order.indexOf('-') !== -1 ? 'desc' : 'asc';
        var orderBy = order.replace('-', '');

        _this.onQueryChange(_extends({}, _this.query, {
          direction: direction,
          orderBy: orderBy
        }));
      };
    }

    _createClass(AdminUserListComponent, [{
      key: '$onInit',
      value: function $onInit() {
        this.limitOptions = (0, _query.getLimitOptions)();
      }
    }, {
      key: 'setUserLocked',
      value: function setUserLocked(user) {
        this.userLockoutChanged(this.EventEmitter({
          userId: user.UserId,
          isLocked: !user.IsLocked
        }));
      }
    }, {
      key: 'onQueryChange',
      value: function onQueryChange(query) {
        this.queryChanged(this.EventEmitter({
          query: query
        }));
      }
    }, {
      key: 'onSearchTextChanged',
      value: function onSearchTextChanged(searchText) {
        this.searchTextChanged(this.EventEmitter({
          searchText: searchText
        }));
      }
    }, {
      key: 'shouldShowColumn',
      value: function shouldShowColumn(columnName) {
        if (!(this.showColumns && this.showColumns.length)) {
          return false;
        }

        return this.showColumns.indexOf(columnName) > -1;
      }
    }]);

    return AdminUserListComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/admin/admin-users/admin-user-list/admin-user-list.component.js